import {
  MAX_MERCHANT_FEATURE_PAUSE_DAYS,
  PauseWindowError,
} from "@redotech/redo-merchant-pause-common/paused-feature";

const PAUSE_WINDOW_ERROR_MESSAGES: Record<PauseWindowError, string> = {
  [PauseWindowError.START_IN_PAST]: "The pause cannot start in the past.",
  [PauseWindowError.END_NOT_AFTER_START]: "The pause must end after it starts.",
  [PauseWindowError.EXCEEDS_MAX_DURATION]: `A pause can last at most ${MAX_MERCHANT_FEATURE_PAUSE_DAYS} days.`,
};

/** Shared by the admin server (RPC error) and admin app (inline form error). */
export function pauseWindowErrorMessage(error: PauseWindowError): string {
  return PAUSE_WINDOW_ERROR_MESSAGES[error];
}
